import type { JSX } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ExternalLink } from 'lucide-react';
import { echoProxyBaseUrl } from '@/auth/msal-config';

export function EchoProxyPage(): JSX.Element {
  const health = useQuery({
    queryKey: ['echoproxy-health', echoProxyBaseUrl],
    enabled: Boolean(echoProxyBaseUrl),
    queryFn: async () => {
      await fetch(new URL('/healthz', echoProxyBaseUrl), { mode: 'no-cors' });
      return true;
    },
  });

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-heading">EchoProxy</h2>

      {echoProxyBaseUrl ? (
        <div className="card space-y-4 p-4">
          <p className="text-sm text-muted-foreground">
            Az EchoProxy az EchoWork LLM-proxy-ja: ezen keresztül haladnak a nyelvi modellekhez (LLM) intézett
            hívások a beállított providerek és modellek felé, egységes, felügyelt és naplózott módon.
            <br />
            Az EchoProxy több technológiai megoldás együttesével adatvédelmi szempontok figyelembevételével
            szűri az LLM felé küldött inputokat.
          </p>
          <p className="text-sm text-muted-foreground">
            Ezek a szűrők az EchoProxy webes felületén állíthatók be és szabhatók testre, ahol a proxy
            működése is áttekinthető és kezelhető. A lenti linkre kattintva az EchoProxy webes felülete nyílik
            meg, ahol ugyanazzal a fiókkal jelentkezhetsz be, amellyel az EchoAdminba is beléptél.
          </p>

          {health.isError ? (
            <div className="space-y-3">
              <div className="card border-amber-200 bg-amber-50 p-4 text-sm text-amber-800">
                Az EchoProxy jelenleg nem érhető el, ezért a megnyitása most nem lehetséges. Próbáld újra,
                vagy jelezd az üzemeltetésnek.
              </div>
              <div className="flex items-center gap-3">
                <button type="button" className="btn-primary inline-flex" disabled>
                  <ExternalLink className="h-4 w-4" /> EchoProxy megnyitása
                </button>
                <button type="button" className="btn-secondary" onClick={() => void health.refetch()}>
                  Újrapróbálás
                </button>
              </div>
            </div>
          ) : health.isPending ? (
            <button type="button" className="btn-primary inline-flex" disabled>
              <ExternalLink className="h-4 w-4" /> Elérhetőség ellenőrzése…
            </button>
          ) : (
            <a href={echoProxyBaseUrl} target="_blank" rel="noreferrer" className="btn-primary inline-flex">
              <ExternalLink className="h-4 w-4" /> EchoProxy megnyitása
            </a>
          )}
        </div>
      ) : (
        <div className="card p-4">
          <p className="text-sm text-muted-foreground">Ehhez a telepítéshez nincs EchoProxy beállítva.</p>
        </div>
      )}
    </div>
  );
}
